"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFrameOrderSearchModel = instanceOfFrameOrderSearchModel;
exports.FrameOrderSearchModelFromJSON = FrameOrderSearchModelFromJSON;
exports.FrameOrderSearchModelFromJSONTyped = FrameOrderSearchModelFromJSONTyped;
exports.FrameOrderSearchModelToJSON = FrameOrderSearchModelToJSON;
exports.FrameOrderSearchModelToJSONTyped = FrameOrderSearchModelToJSONTyped;
/**
 * Check if a given object implements the FrameOrderSearchModel interface.
 */
function instanceOfFrameOrderSearchModel(value) {
    return true;
}
function FrameOrderSearchModelFromJSON(json) {
    return FrameOrderSearchModelFromJSONTyped(json, false);
}
function FrameOrderSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'orderNo': json['orderNo'] == null ? undefined : json['orderNo'],
        'lineId': json['lineId'] == null ? undefined : json['lineId'],
        'lineName': json['lineName'] == null ? undefined : json['lineName'],
        'status': json['status'] == null ? undefined : json['status'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}
function FrameOrderSearchModelToJSON(json) {
    return FrameOrderSearchModelToJSONTyped(json, false);
}
function FrameOrderSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'orderNo': value['orderNo'],
        'lineId': value['lineId'],
        'lineName': value['lineName'],
        'status': value['status'],
        'startDate': value['startDate'] == null ? undefined : (value['startDate'].toISOString()),
        'endDate': value['endDate'] == null ? undefined : (value['endDate'].toISOString()),
    };
}
